import type { FaireProductEntity } from "../../entity_types/product";

export const p_up9q4pqr8p: FaireProductEntity = {
  token: "p_up9q4pqr8p",
  type: "product",
  name: "Manner Kokoscreme Wafers 75g (Austria)",
  brandToken: "b_s2gzfhxg44",
  brandName: "Global Bite Co",
  imageUrl:
    "https://cdn.faire.com/fastly/133efa16ab3923433cd8206ca94cea7289ae61bb27df6d332371199fc242f029.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6da23377a452dc1cea7de8fe8747a5181d9194a75e860fdf0665c35a88e37dbc.jpeg",
  ],
  priceDollars: 2.01,
  description:
    "Manner Kokoscreme Wafers – Crispy, Creamy & Coconut-Flavored (Austria Edition) 🥥🍪🇦🇹\n\nEnjoy a tropical twist on a classic European wafer with Manner Kokoscreme Wafers. Made by Josef Manner & Comp. AG, these light wafer biscuits feature delicate layers filled with smooth coconut cream for a refreshing and creamy flavor.\n\nEach bar contains multiple crisp wafer layers separated by coconut-flavored cream, delivering a satisfying combination of airy crunch and sweet tropical taste. The balanced sweetness and coconut aroma make it a unique variation within the iconic Manner wafer range.\n\nFirst produced in Vienna, Manner wafers have been a staple European snack since the late 19th century and remain famous for their signature layered wafer texture.\n\nWhat to expect:\n\n * \nThin, crispy wafer layers\n\n * \nSmooth coconut cream filling\n\n * \nLight, crunchy texture with tropical flavor\n\n * \nAuthentic Austrian wafer snack\n\n * \nConvenient 75g pack\n\nPerfect for coconut lovers, wafer fans, and anyone exploring classic European confectionery.\n\nSize: 75g\nAllergens: Contains wheat, milk, and soy; may contain traces of nuts.\n\n✨ Light, crispy, and delightfully coconut-sweet—Manner Kokoscreme Wafers (Austria) bring a tropical twist to a classic wafer snack.\n",
  tags: [],
  msrpDollars: 4.02,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:25.972Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
